module.exports = __webpack_public_path__ + "files/25207e78d12f6ef24778476812245a2a.png";